<template lang="html">
   <div class="test-form">
      <div class="my-5 row justify-content-md-center" style="margin: 0">
         <div class="col-12 col-md-11 col-lg-10 col-xl-9">
            <Wizard 
               :forms="[
                  Product.forms.add_user,
                  Product.forms.general_configs,
                  Product.forms.add_charges,
                  Product.forms.target_market,
               ]"
            />
         </div>
      </div>
   </div>
</template>

<script>
import product from "./resources/stores/product.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('product')
   },
   created(){
      utils.registerModule('product',product,this.$store)
   },
   components:{
      Wizard: () => import("@/libs/clarks/components/wizard"),
   },
   computed: {
      ...mapGetters([
         'Product',
         'products'
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
      ])
   },
   mounted(){
      utils.registerModule('product',product,this.$store)
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>